import React from "react";
import GameWindowHeader from "../GameWindowHeader";
import GameWindowBg from "../GameWindowBg";
import ContractWindowCard from "./ContractWindowCard";
import GameData from "../../../gameplay/model/GameData";
import "./ContractsWindow.css";
import {CLIENT_NAMES, DAY_NAMES, getLocoName, GetNameByTypeAndID, STATION_NAMES} from "../../../constants/Constants";
import UtilsFunctions from "../../../utils/UtilsFunctions";

export default class ContractsWindow extends React.Component {
    getDummyData() {
        let data = [];
        for (let i = 0 ; i < GameData.CurrentGame.rentLocoContract.length; i++)
        {
            let contract = GameData.CurrentGame.rentLocoContract[i];
            let loco = GameData.CurrentGame.getLocoById(contract.locoId);
            if(!contract.isCompleted){
                data.push(
                    {
                        code: contract.locoId,
                        startDate: `${DAY_NAMES[contract.startDay % 4]} ${Math.ceil(contract.startDay / 4)}Г`,
                        orderType: "АРЕНДА ЛОКОМОТИВА",
                        locoType: getLocoName(loco.movementType),
                        brigades: 0,
                        brigadePlace: 0,
                        price: contract.cost,
                        from: STATION_NAMES[contract.stationId],
                        to: STATION_NAMES[contract.destinationStationId],
                        seats: 0,
                        due: contract.days,
                        penalty: contract.penalty,
                    }
                )
            }

        }
        for (let i = 0 ; i < GameData.CurrentGame.rentBrigadeContract.length; i++) {
            let contract = GameData.CurrentGame.rentBrigadeContract[i];

            if(!contract.isCompleted){
                data.push(
                    {
                        code: "-",
                        startDate: `${DAY_NAMES[contract.startDay % 4]} ${Math.ceil(contract.startDay / 4)}Г`,
                        orderType: "АРЕНДА БРИГАДЫ",
                        locoType: "-",
                        brigades: contract.count,
                        brigadePlace: GetNameByTypeAndID(contract.type, contract.id),
                        price: contract.cost,
                        from: STATION_NAMES[contract.stationId],
                        to: STATION_NAMES[contract.destinationStationId],
                        seats: 0,
                        due: contract.days,
                        penalty: contract.penalty,
                    }
                )
            }
        }
        for (let i = 0 ; i < GameData.CurrentGame.rentStationPlaceContract.length; i++) {
            let contract = GameData.CurrentGame.rentStationPlaceContract[i];

            if(!contract.isCompleted){
                let place = CLIENT_NAMES[contract.client] || "Прочее";
                data.push(
                    {
                        code: "-",
                        startDate: `${DAY_NAMES[contract.startDay % 4]} ${Math.ceil(contract.startDay / 4)}Г`,
                        orderType: "АРЕНДА МЕСТА",
                        locoType: "-",
                        brigades: 0,
                        brigadePlace: `${STATION_NAMES[contract.station]} (${place})`,
                        price: contract.cost,
                        from: "-",
                        to: "-",
                        seats: contract.count,
                        due: contract.days,
                        penalty: contract.penalty,
                    }
                )
            }
        }
        for (let i = 0 ; i < GameData.CurrentGame.rentTrainCarContract.length; i++) {
            let contract = GameData.CurrentGame.rentTrainCarContract[i];

            if(!contract.isCompleted){
                data.push(
                    {
                        code: "-",
                        startDate: `${DAY_NAMES[contract.startDay % 4]} ${Math.ceil(contract.startDay / 4)}Г`,
                        orderType: "АРЕНДА ВАГОНОВ",
                        locoType: "-",
                        brigades: 0,
                        brigadePlace: `-`,
                        price: contract.cost,
                        from:  STATION_NAMES[contract.stationId],
                        to: "-",
                        seats: contract.count,
                        due: contract.days,
                        penalty: contract.count * 50000,
                    }
                )
            }
        }
        return data;
    }

    render() {
        let content = [];
        // fetch contracts from GameData (?)
        let contracts = this.getDummyData();

        let scrollStyles = {
            overflowY: "scroll",
            height: "270px"
        };

        content.push(<ContractWindowCard
            index={0}
            key={0}
            code={"Номер"}
            startDate={"Дата начала"}
            orderType={"Тип заказа"}
            locoType={"Тип локомотива"}
            brigades={"Количество бригад"}
            brigadePlace={"Место"}
            price={"Цена"}
            from={"Станция появления"}
            to={"Станция возврата"}
            seats={"Количество"}
            due={"Срок"}
            penalty={"Штраф (млн)"}
            fontSize={8}
            fontWeight={"normal"}
        />);

        let contractCards = [];

        contracts.forEach((contract, i) => {
          contractCards.push(<ContractWindowCard
                index={i + 1}
                key={i + 1}
                code={contract.code}
                startDate={contract.startDate}
                orderType={contract.orderType}
                locoType={contract.locoType}
                brigades={contract.brigades}
                brigadePlace={contract.brigadePlace}
                price={UtilsFunctions.toPrettyNumber(contract.price)}
                from={contract.from}
                to={contract.to}
                seats={contract.seats}
                due={contract.due}
                penalty={UtilsFunctions.toPrettyNumber(contract.penalty)}
            />);
        });

        content = <div className="contracts-content">
            <div className="contracts-content__header">{content}</div>
            <div className="contracts-content__main" style={scrollStyles}>{contractCards}</div>
        </div>

        return <div className="contracts">
            <GameWindowHeader title="Активные контракты" width={1330} height={40} colorStart={"#FFCC33"} colorEnd={"#F2994A"}
                              onHide={this.props.onHide}  isClosable={true}/>
            <GameWindowBg width={1330} height={300} value={content} />
        </div>;
    }
}
